export default class Balloon extends Phaser.GameObjects.Sprite {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser.GameObjects.Sprite
   */
  constructor(scene, popupGroup, data) {
    let width = scene.cameras.main.width;
    let height = scene.cameras.main.height;
    super(scene, width / 2, height / 2, 'score_popup');
    this.setDepth(30);
    this.overlay = scene.add.image(0, 0, 'white');
    this.overlay.setOrigin(0, 0);
    this.overlay.setDisplaySize(width, height);
    this.overlay.setDepth(this.depth - 5);
    popupGroup.add(this.overlay, true);
    this.overlay.tint = '#000000';
    this.overlay.alpha = 0;

    this.scene = scene;
    this.config = data;
    this.setOrigin(0.5);
    this.scaleX = 1.2;
    this.scaleY = 1.2;
    this.alpha = 0;
    popupGroup.add(this, true);

    let localisation = scene.cache.json.get('localisation');
    let titleText =
      scene.totalCount > 0
        ? localisation["complete_title_score"][window.language]
        : localisation["complete_title_no_score"][window.language];
    // this.title = scene.add.bitmapText(
    //   scene.cameras.main.width / 2,
    //   scene.cameras.main.height / 2 - 160,
    //   'HelloHeadline',
    //   titleText
    // );
    // this.title.setFontSize(70);

   
    this.title = scene.add.text(scene.cameras.main.width / 2, scene.cameras.main.height / 2 - 170, titleText.text, {fontFamily: titleText.font});
    this.title.setFontSize(Number.parseFloat(titleText.size));
    this.title.setPadding(0,20,0,20);
    this.title.setOrigin(0.5);
    popupGroup.add(this.title);
    this.title.alpha = 0;
    this.title.setDepth(this.depth + 1);

    // this.score = scene.add.bitmapText(
    //   scene.cameras.main.width / 2,
    //   scene.cameras.main.height / 2,
    //   'HelloHeadline',
    //   'score: ' + scene.totalCount
    // );
    // this.score.setFontSize(60);

    this.score = scene.add.text(scene.cameras.main.width / 2, scene.cameras.main.height / 2, localisation["complete_score"][window.language].text + scene.totalCount, {fontFamily: localisation["complete_score"][window.language].font});
    this.score.setFontSize(Number.parseFloat(localisation["complete_score"][window.language].size));
    this.score.setPadding(0,20,0,20);
    this.score.setOrigin(0.5);
    popupGroup.add(this.score);
    this.score.alpha = 0;
    this.score.setDepth(this.depth + 1);

    if (localStorage.getItem('highscore') === null) {
      localStorage.setItem('highscore', 0);
    }

    if (scene.totalCount > localStorage.getItem('highscore')) {
      localStorage.setItem('highscore', scene.totalCount);
    }

    // this.highScore = scene.add.bitmapText(
    //   scene.cameras.main.width / 2,
    //   scene.cameras.main.height / 2 + 80,
    //   'HelloHeadline',
    //   'High Score: ' + localStorage.getItem('highscore')
    // );
    // this.highScore.setFontSize(48);

    this.highScore = scene.add.text(scene.cameras.main.width / 2, scene.cameras.main.height / 2 + 80, localisation["complete_hiscore"][window.language].text + localStorage.getItem('highscore'), {fontFamily: localisation["complete_hiscore"][window.language].font});
    this.highScore.setFontSize(Number.parseFloat(localisation["complete_hiscore"][window.language].size));
    this.highScore.setPadding(0,20,0,20);
    this.highScore.setOrigin(0.5);
    popupGroup.add(this.highScore);
    this.highScore.alpha = 0;
    this.highScore.setDepth(this.depth + 1);

    this.playBtn = scene.add.sprite(
      scene.cameras.main.width / 2,
      scene.cameras.main.height / 2 + 240,
      'playBtn'
    );
    this.playBtn
      .setInteractive({ useHandCursor: true })
      .on('pointerdown', () => this.handlePlayButtonDown());
    this.playBtn.alpha = 0;
    this.playBtn.setDepth(this.depth + 1);

    popupGroup.add(this.playBtn);

    //popupGroup.setDepth(5, 0);

    scene.tweens.add({
      targets: this.overlay,
      alpha: 0.5,
      ease: 'Cubic',
      duration: 300
    });

    scene.tweens.add({
      targets: this,
      scaleX: 1,
      scaleY: 1,
      alpha: 1,
      ease: 'Cubic',
      duration: 300
    });

    scene.tweens.add({
      targets: this.title,
      alpha: 1,
      ease: 'Cubic',
      duration: 300,
      delay: 100
    });

    scene.tweens.add({
      targets: this.score,
      alpha: 1,
      ease: 'Cubic',
      duration: 300,
      delay: 200
    });

    scene.tweens.add({
      targets: this.highScore,
      alpha: 1,
      ease: 'Cubic',
      duration: 300,
      delay: 300
    });

    scene.tweens.add({
      targets: this.playBtn,
      alpha: 1,
      ease: 'Cubic',
      duration: 300,
      delay: 400
    });
    this.sting = scene.sound.add('sting', {
      loop: false,
      volume: 0.5
    });
    this.sting.play();
  }

  handlePlayButtonDown() {
    // console.log('Clicked!')
    this.sting.stop();
    this.scene.scene.start('Game', { firstRun: false, lastBG: this.scene.lastBG });
  }

  destroy() {
    // this.characters.destroy();
    if (this.sting !== null) {
      this.sting.stop();
      this.sting = null;
    }

    this.score.destroy();
    this.title.destroy();
    this.highScore.destroy();
    this.playBtn.destroy();
    this.characters = null;
    super.destroy();
  }
}
